<script setup>
import { defineEmits, defineProps } from "vue";
defineEmits(["update:modelValue"]);
defineProps({
  modelValue: String,
  dateTime: { type: Boolean, default: false },
});
</script>
<template>
  <input
    :value="modelValue"
    :type="dateTime ? 'datetime-local' : 'date'"
    class="my-2 min-h-[36px] w-full appearance-none rounded border-2 border-kekkle-dark p-2 text-kekkle-dark shadow-purple-hard-sm dark:bg-kekkle-dark-light dark:text-slate-200"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>
